import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-year-wise',
  templateUrl: './year-wise.component.html',
  styleUrls: ['./year-wise.component.scss']
})
export class YearWiseComponent implements OnInit {

  @Input() config: any;
  @Input() yearData: any;
  @Input() canvasId:string = 'canvas'
  label: any = [];
  yearSumArray: any;
  prevYearSum = 0;

  constructor() { }

  ngOnInit(): void {
    this.generateYears()
  }

  ngOnChanges() {
    if (this.yearData) {
      this.update();
    }
  }

  update() {
    this.yearSumArray = [];
    this.yearData?.data.forEach((control: any) => {
      let value = Object.values(control);
      this.yearSumArray.push(value[0])
    });
  }
  
  generateYears() {
    for (let i = 2017; i <= new Date().getFullYear(); i++) {
      this.label.push(i)
    }
  }

}
